import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Image,
} from 'react-native';
import { ms, s, vs } from '../../utils/responsive';
import { SafeAreaView } from 'react-native-safe-area-context';

export const AIOnboardingPausedScreen = ({ navigation }: any) => {
  const handleResume = () => {
    // TODO: Resume from saved progress
    navigation.replace('AIOnboardingChat', { resume: true });
  };

  const handleSkip = () => {
    // TODO: Mark onboarding as skipped
    navigation.replace('PersonalChecklist');
  };

  return (
    <SafeAreaView style={styles.container}>
      <TouchableOpacity
        style={styles.closeButton}
        onPress={() => navigation.replace('PersonalChecklist')}
      >
        <Text style={styles.closeText}>✕</Text>
      </TouchableOpacity>

      <View style={styles.content}>
        {/* Pause Icon */}
        <View style={styles.iconContainer}>
          <Text style={styles.icon}>⏸️</Text>
        </View>

        {/* Title */}
        <Text style={styles.title}>Onboarding Paused</Text>

        {/* Description */}
        <Text style={styles.description}>
          You can resume anytime from where you left off. We've saved your
          progress.
        </Text>

        {/* Progress Info */}
        <View style={styles.progressCard}>
          <View style={styles.progressRow}>
            <Text style={styles.progressLabel}>Progress</Text>
            <Text style={styles.progressValue}>3 of 7 questions answered</Text>
          </View>
          <View style={styles.progressBar}>
            <View style={[styles.progressFill, { width: '43%' }]} />
          </View>
        </View>

        {/* Action Buttons */}
        <TouchableOpacity
          style={styles.resumeButton}
          onPress={handleResume}
          activeOpacity={0.8}
        >
          <Text style={styles.resumeButtonText}>Resume Chat</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.skipButton}
          onPress={handleSkip}
          activeOpacity={0.8}
        >
          <Text style={styles.skipButtonText}>Skip for Now</Text>
        </TouchableOpacity>

        <Text style={styles.noteText}>
          You can also resume from Settings {">"} Complete Onboarding
        </Text>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F3F6F8',
  },
  closeButton: {
    position: 'absolute',
    top: ms(60),
    right: ms(20),
    zIndex: 10,
    padding: ms(8),
  },
  closeText: {
    fontSize: ms(28, 0.3),
    color: '#666',
  },
  content: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: ms(32),
  },
  iconContainer: {
    marginBottom: ms(24),
  },
  icon: {
    fontSize: ms(80, 0.3),
  },
  title: {
    fontSize: ms(28, 0.3),
    fontWeight: '700',
    color: '#1C2C4F',
    marginBottom: ms(16),
    textAlign: 'center',
  },
  description: {
    fontSize: ms(16, 0.3),
    color: '#666',
    textAlign: 'center',
    lineHeight: ms(24, 0.3),
    marginBottom: ms(32),
  },
  progressCard: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: ms(16),
    padding: ms(20),
    marginBottom: ms(32),
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 3,
  },
  progressRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: ms(12),
  },
  progressLabel: {
    fontSize: ms(14, 0.3),
    fontWeight: '600',
    color: '#666',
  },
  progressValue: {
    fontSize: ms(14, 0.3),
    fontWeight: '600',
    color: '#29BFC0',
  },
  progressBar: {
    height: s(8),
    backgroundColor: '#E0E0E0',
    borderRadius: ms(4),
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#29BFC0',
    borderRadius: ms(4),
  },
  resumeButton: {
    width: '100%',
    backgroundColor: '#29BFC0',
    borderRadius: ms(25),
    paddingVertical: ms(16),
    alignItems: 'center',
    marginBottom: ms(12),
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  resumeButtonText: {
    fontSize: ms(18, 0.3),
    fontWeight: '600',
    color: '#FFFFFF',
  },
  skipButton: {
    width: '100%',
    backgroundColor: '#6B7280',
    borderRadius: ms(25),
    paddingVertical: ms(16),
    alignItems: 'center',
    marginBottom: ms(24),
  },
  skipButtonText: {
    fontSize: ms(18, 0.3),
    fontWeight: '600',
    color: '#FFFFFF',
  },
  noteText: {
    fontSize: ms(13, 0.3),
    color: '#999',
    textAlign: 'center',
    fontStyle: 'italic',
  },
});
